import React from "react";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SpinnerLoading from "../../../components/pageComponents/SpinnerLoading";

const TableItems = ({
                        rows,
                        handleEditBeneficio,
                        handleActiveInactiveBeneficio,
                        isFetching,
                    }) => {
    if (isFetching)
        return (
            <div className="d-flex" style={{height: "60vh"}}>
                <SpinnerLoading/>
            </div>
        );

    if (!rows.length)
        return (
            <div className="d-flex justify-content-center py-5">
                No se encontraron beneficios
            </div>
        );

    return (
        <CustomCardWrapper>
            {rows.map((row, i) => (
                <Card isActive={row.EsActivo ?? true} key={`${row.IdBeneficioItem}-${i}`}>
                    <div className="inner-content">
                        <CustomCardImage src={row.ImgSrc} loading="lazy"/>
                    </div>
                    <div className="icons">
                        {row.PuedeEditar && (
                            <FontAwesomeIcon
                                icon="edit"
                                title="Editar Beneficio"
                                size="4x"
                                className="hand-pointer"
                                onClick={() => handleEditBeneficio(row)}
                            />
                        )}
                        <FontAwesomeIcon
                            icon={row.EsActivo ? "ban" : "circle-notch"}
                            title={row.EsActivo ? "Inactivar" : "Activar"}
                            size="4x"
                            className="hand-pointer"
                            onClick={() => handleActiveInactiveBeneficio(row)}
                        />
                    </div>
                    <div className="card-text-descripcion"><p className="m-0">{row.Descripcion}</p></div>
                    <div className="card-text-monto"><p className="m-0">S/. {row.Monto}</p></div>
                </Card>

            ))}
        </CustomCardWrapper>
    );
};

export default TableItems;

const CustomCardWrapper = styled.div`
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(auto-fill, 300px);
    margin: 15px;
`;

const CustomCardImage = styled.img`
  width: 100%;
  display: block;
  object-fit: cover;
  object-position: center right;
`;

const Card = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 73% 17% 10%;
    height: 420px;
    

    border: 1px solid #d5d0d0;
    border-radius: 8px;
    position: relative;
    overflow: hidden;

    &:hover {
        .icons {
            visibility: visible;
            opacity: 1;
        }
    }

    .inner-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s ease;
    }

    .icons {
        visibility: hidden;
        opacity: 0;
        display: flex;
        position: absolute;
        justify-content: center;
        align-items: center;
        color: white;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        gap: 70px;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        svg {
            transition: color 0.3s;
            color: #00659D;

            &:hover {
                color: #3a87c8;
            }
        }
    }

    .card-text-descripcion {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        height: 100%;
    }

    .card-text-monto {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 18px;
        height: 100%;
    }

    &:hover {
        transform: translate3d(0, 0, 0);
    }

`;